module.exports = __webpack_public_path__ + "img/header-weddingRingsForestGreen@2x.f75736e.webp";